import TrackingUtils from "@tracking/utils/TrackingUtils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import { parseQuery } from "../slices/utils";

export const getDataEdiByApelido = createAsyncThunk(
  "ediApp/transportadoras/getDataEdiByApelido",
  async (_, { dispatch, getState }) => {
    const state: any = getState();
    const { dataHoraInicial, dataHoraFinal, idApelido } =
      state.ediApp.edi.ediGeralFilters;
    const data = {
      dataHoraInicial,
      dataHoraFinal,
      apelidoTransportadora: idApelido,
    };
    let response;
    dispatch(openLoading());
    try {
      const parsedUrl = TrackingUtils.buildQueryStringArray(
        "/edi/arquivos-ocorrencias",
        data
      );
      response = await API.get(`${parsedUrl}&tipoDocumento=Todos`);
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos. Caso estejam, solicite contato com a transportadora.",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const getDataListByFilter = createAsyncThunk(
  "ediApp/transportadoras/getDataListByFilter",
  async (data: any, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get(
        TrackingUtils.buildQueryStringArray(
          `/edi/arquivos-ocorrencias`,
          parseQuery(data)
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos. Caso estejam, solicite contato com a transportadora.",
          btnLabel: "Voltar",
        })
      );
    }
    dispatch(closeLoading());
    return response.data;
  }
);
